import React from "react";
import * as Popover from "@radix-ui/react-popover";
import { MoreVertical, UserCog, PenLine, UserCheck, UserX, Skull, FileWarning, Calculator, Share2, Trash, Database, RefreshCw } from "lucide-react";
import { Button } from "../../ui/button";

export function RowActionsMenu({
    onEditDados,
    onRegisterManual,
    onToggleAtivo,
    onToggleFalecido,
    onTogglePendenteDocumentacao,
    onToggleRecalculo,
    onOpenCrm,
    onUnlink,
    onExternalQuery,
    onSyncEnvelope,
    syncingEnvelope = false,
    ativo,
    falecido,
    pendenteDocumentacao,
    requerRecalculo,
    showRegisterManual = false,
    showEditDados = false,
    showToggleAtivo = false,
    showToggleFalecido = false,
    showTogglePendenteDocumentacao = false,
    showToggleRecalculo = false,
}) {
    const [open, setOpen] = React.useState(false);

    const handleAction = (fn) => {
        setOpen(false);
        fn();
    };

    return (
        <Popover.Root open={open} onOpenChange={setOpen}>
            <Popover.Trigger asChild>
                <Button variant="ghost" size="sm" title="Mais ações">
                    <MoreVertical className="h-4 w-4 text-muted-foreground" />
                </Button>
            </Popover.Trigger>
            <Popover.Portal>
                <Popover.Content
                    align="end"
                    sideOffset={4}
                    className="z-50 min-w-[180px] rounded-lg border border-border bg-card shadow-md py-1 outline-none"
                    onInteractOutside={() => setOpen(false)}
                >
                    {showEditDados && (
                        <button
                            className="flex w-full items-center gap-2.5 px-3 py-2 text-sm text-foreground hover:bg-muted transition-colors"
                            onClick={() => handleAction(onEditDados)}
                        >
                            <UserCog className="h-4 w-4 text-violet-500 shrink-0" />
                            Editar dados pessoais
                        </button>
                    )}
                    {showRegisterManual && (
                        <button
                            className="flex w-full items-center gap-2.5 px-3 py-2 text-sm text-foreground hover:bg-muted transition-colors"
                            onClick={() => handleAction(onRegisterManual)}
                        >
                            <PenLine className="h-4 w-4 text-amber-600 shrink-0" />
                            Registrar assinatura manual
                        </button>
                    )}
                    {showToggleAtivo && (
                        ativo === false ? (
                            <button
                                className="flex w-full items-center gap-2.5 px-3 py-2 text-sm text-foreground hover:bg-muted transition-colors"
                                onClick={() => handleAction(onToggleAtivo)}
                            >
                                <UserCheck className="h-4 w-4 text-green-600 shrink-0" />
                                Reativar cedente
                            </button>
                        ) : (
                            <button
                                className="flex w-full items-center gap-2.5 px-3 py-2 text-sm text-foreground hover:bg-muted transition-colors"
                                onClick={() => handleAction(onToggleAtivo)}
                            >
                                <UserX className="h-4 w-4 text-red-500 shrink-0" />
                                Inativar cedente
                            </button>
                        )
                    )}
                    {showToggleFalecido && (
                        <button
                            className="flex w-full items-center gap-2.5 px-3 py-2 text-sm text-foreground hover:bg-muted transition-colors"
                            onClick={() => handleAction(onToggleFalecido)}
                        >
                            <Skull className="h-4 w-4 text-muted-foreground shrink-0" />
                            {falecido ? "Reverter falecido" : "Marcar como falecido"}
                        </button>
                    )}
                    {showTogglePendenteDocumentacao && (
                        <button
                            className="flex w-full items-center gap-2.5 px-3 py-2 text-sm text-foreground hover:bg-muted transition-colors"
                            onClick={() => handleAction(onTogglePendenteDocumentacao)}
                        >
                            <FileWarning className={`h-4 w-4 shrink-0 ${pendenteDocumentacao ? "text-amber-500" : "text-muted-foreground"}`} />
                            {pendenteDocumentacao ? "Remover pend. documentação" : "Marcar pend. documentação"}
                        </button>
                    )}
                    {showToggleRecalculo && (
                        <button
                            className="flex w-full items-center gap-2.5 px-3 py-2 text-sm text-foreground hover:bg-muted transition-colors"
                            onClick={() => handleAction(onToggleRecalculo)}
                        >
                            <Calculator className={`h-4 w-4 shrink-0 ${requerRecalculo ? "text-amber-500" : "text-muted-foreground"}`} />
                            {requerRecalculo ? "Liberar proposta (sem recálculo)" : "Marcar proposta em recálculo"}
                        </button>
                    )}
                    <button
                        className="flex w-full items-center gap-2.5 px-3 py-2 text-sm text-foreground hover:bg-muted transition-colors"
                        onClick={() => handleAction(onOpenCrm)}
                    >
                        <Share2 className="h-4 w-4 text-emerald-500 shrink-0" />
                        Gerenciar CRM
                    </button>
                    {onExternalQuery && (
                        <button
                            className="flex w-full items-center gap-2.5 px-3 py-2 text-sm text-foreground hover:bg-muted transition-colors"
                            onClick={() => handleAction(onExternalQuery)}
                        >
                            <Database className="h-4 w-4 text-blue-500 shrink-0" />
                            Consulta externa
                        </button>
                    )}
                    {onSyncEnvelope && (
                        <button
                            className="flex w-full items-center gap-2.5 px-3 py-2 text-sm text-foreground hover:bg-muted transition-colors disabled:opacity-50"
                            onClick={() => handleAction(onSyncEnvelope)}
                            disabled={syncingEnvelope}
                        >
                            <RefreshCw className={`h-4 w-4 text-indigo-500 shrink-0 ${syncingEnvelope ? "animate-spin" : ""}`} />
                            {syncingEnvelope ? "Sincronizando..." : "Sincronizar envelope ClickSign"}
                        </button>
                    )}
                    <div className="my-1 border-t border-border" />
                    <button
                        className="flex w-full items-center gap-2.5 px-3 py-2 text-sm text-red-600 hover:bg-statusErrorBg transition-colors"
                        onClick={() => handleAction(onUnlink)}
                    >
                        <Trash className="h-4 w-4 shrink-0" />
                        Desvincular
                    </button>
                </Popover.Content>
            </Popover.Portal>
        </Popover.Root>
    );
}
